import { getDevicePixelRatio } from '@djs';
import { envs } from '../core/env';

const isRetina = getDevicePixelRatio() >= 2;

function getVideoSource(path: string, name: string): string {
  return `${envs.STATIC_ASSETS_URL}${path}/${name}.mp4`;
}

export const videoGetters = {
  installInstruction: () =>
    getVideoSource('pwa-installer/video', isRetina ? 'safari-instruction-2x' : 'safari-instruction-1x'),
};
